var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('md-card',[_c('md-card-header',[_c('span',{staticClass:"md-title"},[_vm._v(_vm._s(_vm.L(_vm.titleKey)))])]),_c('md-card-content',[_c('GChart',{attrs:{"type":"LineChart","data":_vm.chartData,"options":_vm.chartOptions}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }